'use client'

import { useEffect } from 'react'

// NEXT_PUBLIC_VERBOSE_ERRORS=0 으로 빌드하면 상세(message·stack)를 숨기고 digest만 노출합니다.
// (참고: next.config.js 의 productionBrowserSourceMaps 도 같이 끄세요.)
const VERBOSE = process.env.NEXT_PUBLIC_VERBOSE_ERRORS !== '0'

interface Props {
  error: Error & { digest?: string }
  reset: () => void
}

export default function RouteError({ error, reset }: Props) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="min-h-screen p-8 font-mono text-sm bg-white">
      <header className="mb-4">
        <h1 className="text-base font-bold text-red-600">Student · 클라이언트 예외</h1>
        <p className="text-[11px] text-zinc-500 mt-1">
          {VERBOSE
            ? '테스트 모드: 상세 정보를 그대로 표시합니다. 운영 배포 시 NEXT_PUBLIC_VERBOSE_ERRORS=0 으로 게이팅하세요.'
            : '예기치 못한 오류가 발생했습니다.'}
        </p>
      </header>

      {VERBOSE ? (
        <section className="space-y-3 max-w-4xl">
          <Field label="message">{error.message || '(empty)'}</Field>
          {error.digest && (
            <Field label="digest (서버 액션 매핑용)">
              {error.digest}
              <div className="mt-1 text-[10px] text-zinc-400">
                서버 액션에서 발생한 throw는 message가 비어 있고 digest만 옵니다. 실제
                메시지는 <code>pm2 logs lumi-student</code> 에서 이 digest로 검색하세요.
              </div>
            </Field>
          )}
          <Field label="stack" smaller>
            {error.stack || '(empty)'}
          </Field>
        </section>
      ) : (
        error.digest && (
          <section className="max-w-md">
            <Field label="reference">{error.digest}</Field>
          </section>
        )
      )}

      <button
        type="button"
        onClick={reset}
        className="mt-5 text-xs px-3 py-1.5 rounded-md bg-zinc-900 text-white font-medium hover:bg-zinc-800"
      >
        다시 시도
      </button>
    </div>
  )
}

function Field({
  label,
  smaller,
  children,
}: {
  label: string
  smaller?: boolean
  children: React.ReactNode
}) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-wider font-semibold text-zinc-500 mb-1">
        {label}
      </div>
      <pre
        className={`bg-zinc-50 border border-zinc-200 rounded p-2 whitespace-pre-wrap break-words ${
          smaller ? 'text-[11px]' : ''
        }`}
      >
        {children}
      </pre>
    </div>
  )
}
